export default class Attributs {

    // Processa atributos de um objeto baseado no tipo
    static process(key, value) {

        let result;

        switch (key) {
            case 'info':
                result = value
                break;
            case 'tags':
                result = `tags: ${value}`
                break;
            
            default:
                result = '' // ignora o atributo
                break;
        }

        return result;
   
    }

}
